import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingChat from "../components/FloatingChat";
import AITestAgent from "../components/AITestAgent";
import Hero from "../components/sections/Hero";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import VerifyCertificate from "../components/sections/VerifyCertificate";
import Courses from "../components/sections/Courses";
import MissionVision from "../components/sections/MissionVision";
import Impact from "../components/sections/Impact";
import Gallery from "../components/sections/Gallery";
import Contact from "../components/sections/Contact";
import Services from "../components/sections/Services";
import Affiliations from "../components/sections/Affiliations";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <WhyChooseUs />
        <Services />
        <VerifyCertificate />
        <Courses />
        <MissionVision />
        <Impact />
        <Gallery />
        <Affiliations />
        <Contact />
      </main>
      <Footer />
      <FloatingChat />
      <AITestAgent />
    </div>
  );
}
